export default {
  'site.title': '手机商城',

  'about.title': 'About SuperAcme',

  'page.name.wifi': '如何区分5G和2.4G Wi-Fi',

  // 请求配置
  requestConfiguration: 'Request configuration',
  // 处理审批的审查和批准
  reviewAndApproval: '处理确认审核',
  // 取消
  cancel: '取消',
  // 确定
  ok: '确定',
  // 您确定要注销您的帐户吗？
  confirmDeregisterAccount: '确认注销',
  // 稍后
  later: '我再想想',
  // 您确定要删除组中的设备
  confirmDeleteDevicesInGroup: '是否确定删除分组下设备',
  // 删除
  delete: '删除',

  // 编辑分组
  editGroup: '编辑分组',

  // 返回
  back: '返回',

  // 图标
  icon: '图标',
  // 标题
  title: '主标题',
  // 副标题
  subtitle: '副标题',
  // 按钮操作点
  buttonActionPoint: '按钮行动点',
  // 全屏
  fullScreen: '是否全屏',
  // 模式
  mode: '模式为',
  // 你可以配置一张图片。
  configureImage: '可配置一张图片',
  // 获取数据失败。
  fetchDataFailed: '数据获取失败',
  // 检查网络并点击重新加载。
  checkNetworkAndReload: '请检查网络后重试',
  // 请检查输入错误
  needCheckError: '请检查输入错误',
  // 点击重试
  tapToRetry: '重试',
  // 没有数据
  noData: '暂无数据',
  // 正在加载...
  loading: '加载中',
  // 不要使用
  doNotUse: '不使用',
  // 缺失参数
  missingParameters: 'Missing parameters',
  // 已过期
  expired: '过期',
  // 无效
  invalid: '无效',
  // 无效请求
  invalidRequest: '请求无效',
  // 没有权限
  noPermission: '无权限',
  // 付款
  payment: '付款',
  // 待付款
  pendingPayment: '待付款',
  // 支付成功
  paymentSuccessful: '支付成功',
  // 支付失败
  paymentFailed: '支付失败',
  // 激活中
  activating: '开通中',
  // 通过使用递归方法获取目录中的所有文件的路径
  getPathsOfAllFiles: '递归获取目录下的所有文件路径',
  // 在文件中提取所有汉字字符串
  extractChineseStrings: '提取文件中的所有中文字符组',
  // 去重数据结构
  deduplicateDataStructures: '数据结构去除重复项',
  // 创建或清除输出文件
  createOrClearOutputFiles: '创建或清空输出文件',
  // 例如，搜索目录中的所有文件
  exampleSearchFiles: 'For example, to search all the files in a directory',
  // 注销帐户
  deregisterAccount: '注销账号',
  // 在注销帐户之前三思而后行。
  thinkBeforeDeregister: '请不要轻易注销账号，账号注销是不可逆的操作，请谨慎操作',
  // 所有权益在帐户注销后清除。
  benefitsCleared: '注销账号后清空所有权益',
  // 在您注销帐户后，
  afterDeregisterAccount: '账号注销后',
  // 您通过使用此帐户获得的权限、权益和功能立即失效，
  benefitsAndFeaturesInvalid:
    '一旦注销账号，您对应的权限、权益和功能将不再生效（包括但不限于之前购买、赠送的各种云存储、算法、会员等）；',
  // 如果您仍在使用CiNMOORE产品，
  stillUsingCiNMOOREProducts: '若您还在继续使用的相关产品，请不要注销账号。',
  // 帐户责任
  accountResponsibilities: '账号责任与职责',
  // 帐户的删除不免除您对使用帐户进行的行为的责任或减少您的责任。
  accountDeletionResponsibilities: '账号注销并不意味着注销前的账户行为和责任得到豁免或减轻',
  // 在您注销帐户后，关联的数据被清除，无法恢复
  associatedDataCleared: '在您注销帐户后，关联的数据被清除，无法恢复，注销后设备不能正常工作',
  // 上一个
  previous: '返回上一页',
  // 系统错误
  systemError: '系统错误',
  // 评价我们
  rateUs: '请评价',
  // 输入有效的电话号码
  enterValidPhoneNumber: '请输入正确的手机号码',
  // 提交成功
  submissionSuccessful: '提交成功',
  // 提交失败
  submissionFailed: '提交失败',
  // 重试
  retry: '请重试',
  // 评价
  review: '评价',
  // 输入您的建议
  enterYourSuggestion: '请输入您的建议',
  // 联系信息
  contactInformation: '联系方式',
  // 输入电话号码
  enterPhoneNumber: '请输入手机号码',
  // CiNMOORE产品试用
  cinmooreProductTrial: '神眸体验官',
  // 悟空简介
  wukongIntroduction: '悟空产品介绍',
  // 产品图片
  productImage: '产品图片',
  // 遵循将传统文化与技术和艺术相融合的设计原则，
  adheringToDesignPrinciple: '遵循传统文化和科技艺术融合的设计理念',
  // 产品的设计看起来像
  productDesignedToLookLike:
    'the product is designed to look like Sun Wukong’s eyes and the Golden Hoop',

  //  如果您的体验报告优秀，您将被授予我们的惊喜奖品。
  excellentExperienceReport:
    'If your experience report is excellent, you’ll be awarded our surprise prizes.',
  // 申请已提交
  applicationSubmitted: '已申请',
  // 申请
  apply: '应用',

  // 输入的名称不能包含表情
  emojiValidation: '输入的名称不能包含表情',

  // 提交
  submit: '提交',

  // 提交材料
  submitMaterials: '提交资料',
  // 手机号码
  mobileNumber: '手机号码',
  // 微信ID
  weChatID: '微信号',
  // 输入一个微信ID
  enterWeChatID: '请输入微信号',
  // 反馈
  feedback: '反馈意见',
  // 微信官方帐号图像
  weChatOfficialAccountImage: '公众号图片',
  // 关注CiNMOORE的微信官方帐号以提交您的反馈
  followWeChatOfficialAccount: '关注神眸公众号反馈意见',
  // 输入一个新的群组名称
  enterNewGroupName: '请输入新的分组名称',
  // 群组名称太长
  groupNameTooLong: '分组名称过长',
  // 重命名群组
  renameGroup: '重命名分组',
  // 导入设备
  importDevice: '转入设备',
  // 重命名
  rename: '重命名',
  // 您确定要删除群组吗？
  confirmDeleteGroup: 'Are you sure you want to delete the group?',
  // 重命名
  renamed: '重命名成功',
  // 必须指定名称
  nameMustBeSpecified: '新增分组名称不能为空',
  // 添加群组
  addGroup: '添加分组',
  // 输入群组名称
  enterGroupName: '请输入分组名称',
  //  设备
  devices: '台设备',

  // 设置充值引导
  setRechargeGuide: '设备重置引导',

  // 问题排查
  troubleshooting: '问题排查',

  // 您有云服务套餐可转移
  packageCanTransfer: '您有神眸权益(原云存套餐)可转移',

  // 注销账号后，您对应权限和服务将失效
  cancelAccountService: '注销账号后，您对应权限和服务将失效',

  // 存在已绑定设备，请删除后再试
  boundDelete: '存在已绑定设备，请删除后再试',

  // 去转移
  goToTransfer: '去转移',

  // 忍痛注销
  reluctantlyCancel: '忍痛注销',

  share: '分享',

  // 已添加
  added: '已添加',
  // 管理群组
  manageGroup: '管理分组',
  // 设备图像
  deviceImage: '设备封面',
  // 选择一个设备
  selectADevice: '请选择设备',
  // 已导入
  imported: '转入成功',
  // 选择要导入的设备
  selectDeviceToImport: '选择转入的设备',

  // 重新启动设备
  restartDevice: '请重启设备',
  // 向左滑动以检查每个型号的电源按钮位置
  swipeLeftToCheckPowerButton: '请左滑查看各机型开机键示意图',
  // 第一步
  stepOne: '第一步',
  // 第二步
  stepTwo: '第二步',
  // 检查设备是否发出语音提示，提醒设备已启动
  checkVoiceAnnouncement: '确定设备语音播报“设备已开机”',
  // 如果没有语音提示，请使用充电器为设备充电约
  noVoiceAnnouncement:
    '如果没有听到设备语音播报“设备已开机”，请插上充电器充电10分钟左右，直到设备语音播报“设备已开机”',
  // 否则，请尝试重新启动您的路由器。
  tryRestartingRouter: '若以上操作无效，请尝试重启家里的路由器设备。',

  // 连续短按2下,听到设备语音播报重置成功
  pressTwiceToReset: '连续短按2下,听到设备语音播报重置成功',

  // 连续短按2下,唤醒设备
  pressTwiceToWakeUp: '连续短按2下,唤醒设备',

  // 双击 RST 键,听到设备语音播报重置成功
  doubleClickRST: '双击RST键, 重置设备',

  // 以具体产品为准,图仅供部分产品参考
  specificProductReference: '以具体产品为准,图仅供部分产品参考',

  // 短按电源键3秒左右，唤醒设备
  pressWakeUp: '双击RST键，听到设备语音播报重置成功',

  // 个人信息
  personalInformation: '个人资料',
  // 头像
  avatar: '头像',
  // 用户名
  username: '用户名',
  // 电子邮件
  email: '邮箱',
  // 更改密码
  changePassword: '修改密码',
  // 有绑定设备。
  boundDevices: '存在已绑定设备，请删除后再试',
  // 网络错误
  networkError: '网络错误',
  // 稍后重试
  tryAgainLater: '请稍后再试',
  // 输入用户名
  enterUsername: '请输入用户名',
  // 用户名太长
  usernameTooLong: '用户名称请不要超过24个字符',
  // 修改成功
  modificationSuccessful: '修改成功',
  // 修改失败
  modificationFailed: '修改失败',
  // 保存
  save: '保存',
  // 绑定的手机号码
  boundMobileNumber: '当前绑定手机号',
  // 未绑定手机号码
  noBoundMobileNumber: '当前未绑定手机号',
  // 更改手机号码
  changeMobileNumber: '修改手机号',
  // 所有的共享权限都被取消了。
  allSharedPermissionsCanceled: '取消全部共享成功',
  // SuperACME
  superACME: '研极',
  // Meari
  meari: '觅睿',
  // Jijia
  jijia: '积嘉',
  // 取消所有的共享权限吗？
  confirmCancelAllSharedPermissions: '是否确定取消全部共享权限',
  // 取消全部
  cancelAll: '取消全部共享',
  // 共享给
  sharedWith: '已分享给',

  startShareDevice: '点击右上角分享设备',
  // 的权限
  permissions: 'permissions',
  // 修改权限
  changePermissions: '更改权限',
  // 您确定要取消
  confirmCancelSharedPermissions: "Are you sure you want to cancel 's shared permissions?",
  // 取消共享
  cancelSharing: '取消共享',
  // 允许控制
  allowControl: '允许控制',
  // 可以查看设备信息并控制设备。
  canViewAndControlDevices: '可浏览设备信息并可控制设备',
  // 仅查看
  viewOnly: '仅可查看',

  // 可以查看设备信息但不能控制设备。
  canViewDeviceInfo: '可浏览设备信息，不可控制设备',

  // 可浏览设备信息，仅可控制设备部分功能
  canViewDeviceInfoX: '可浏览设备信息，仅可控制设备部分功能',

  // 无法控制设备
  cannotControlDevices: '不可控制设备',
  // 我的共享
  mySharing: '我的共享',
  // 网络错误。稍后再试。
  networkErrorTryAgain: 'Network error. Try again later.',
  // 共享设置
  sharingSettings: '共享设置',
  // 请设置Ta的权限
  settingAuth: '请设置Ta的权限',
  // 下一步
  next: '下一步',
  // 生成QR码的时间
  qrCodeGenerationTime: '二维码生成时间：',
  // 有效期
  validityPeriod: '有效期',
  // 至
  to: '至',
  // 分钟
  minutes: '分钟',

  // 仅限单次使用
  forSingleUseOnly: '可使用一次',

  // 返回首页
  returnToHomePage: '返回首页',
  // 如果QR码已使用或过期，管理员应该分享, 一个新的QR码。
  shareNewQRCode: '若已使用或过期需管理员重新分享二维码',
  shareNewQRCodeNew:
    '若已使用或过期需管理员重新分享二维码。分享后即可浏览设备视频，如需控制设备，需添加为家庭成员。',
  // 前往手机应用商店下载CiNMOORE
  goToAppStore: '请先到各大手机应用商店下载"神眸"App。在主页点击右上角“+”扫描此二维码即可。',
  // CiNMOORE Smart
  cinmooreSmart: '神眸智品',
  // 步骤
  step: '步骤',
  // 这个文件
  thisFile: '该文件由',
  // 自动生成
  automaticallyGenerated: '自动生成',
  // 不要修改
  doNotModify: '请勿直接修改',
  // API
  api: '接口',
  // 查看CiNMOORE产品的请求类型
  reviewCinmooreProductRequestType: 'Review CiNMOORE products’s Request type',
  // 类别
  category: '请求类型',
  // 售后活动
  afterSalesActivities: '分类',
  // 请求头
  requestHeader: '售后活动',
  // 更新时间
  updateTime: '请求头',
  // 星级数量
  numberOfStars: '更新时间',
  // 建议
  suggestion: '星星颗数',
  // 响应类型
  responseType: '电话号码',
  // 查询用户是否之前申请过CiNMOORE产品的试用
  queryUserAppliedForTrial: '返回类型',
  // 之前申请过CiNMOORE产品的试用
  appliedForCiNMOORETrialBefore: '查询是否已经申请过神眸体验官',
  // 否
  no: '没有',
  // 申请时间
  applicationTime: '否',
  // 时间戳（毫秒）
  timestampInMilliseconds: '申请时间',
  // 申请CiNMOORE产品的试用
  applyForCiNMOORETrial: '毫秒级时间戳',
  // 上传头像
  uploadAvatar: '申请成为神眸体验官',
  // 登录后使用的API
  apisUsedAfterLogin: '用户头像上传',
  // 编码的图像数据
  encodedImageData: '登陆后相关接口',
  // 绑定用户可以更改绑定的手机号码和电子邮件地址。
  changeBoundMobileAndEmail: '编码的图片数据',
  // 电话号码的区号
  areaCodeOfPhoneNumber: '用户绑定换绑电话号码邮箱',
  // 中国大陆用户可以使用以下之一。
  chineseMainlandUsersOptions: '电话号码区号',
  // 指定这个或电子邮件地址的其中之一
  specifyEitherThisOrEmail: '中国大陆可以用如下的一种表示',
  // 当选中时
  whenSelected: '和邮箱二选一',
  // 必填字段
  requiredField: '选中时',
  // 指定这个或手机号码的其中之一
  specifyEitherThisOrMobile: '字段必传',
  // 用户注销
  userDeregistration: '和电话号码二选一',
  // 注销
  logout: '用户注销',
  // 获取用户操作记录
  obtainUserOperationRecords: '退出登录',
  // 开始时间
  startTime: '获取用户操作记录',
  // 格式
  format: '开始时间',
  // 结束时间
  endTime: '格式为',
  // 页大小
  pageSize: '分页号',
  // 每页的条目数
  entriesPerPage: '每页条数',
  // 数据
  data: '每页数据条数',
  // 当前操作名称
  currentOperationName: '数据',
  // 当前操作类型
  currentOperationType: '当前操作名称',
  // 客户端
  client: '终端名称',
  // 操作时间
  operationTime: '客户端',
  // 重置密码
  resetPassword: '操作时间',
  // 当前密码
  currentPassword: '密码重置',
  // 新密码
  newPassword: '旧密码',
  // 是否启用设备绑定
  enableDeviceBinding: 'Enable device binding',
  // 启用
  enable: '是否开启终端绑定',
  // 关闭
  close: '开启',
  // 获取已绑定设备的列表
  obtainBoundDevicesList: '关闭',
  // 云平台上的唯一用户
  uniqueUserOnCloudPlatform: '获取终端绑定列表',
  // 唯一设备
  uniqueDevice: '云平台用户唯一',
  // 设备名称
  deviceName: '设备名称',
  // 用户解绑定的设备
  deviceUnboundByUser: '终端设备名称',
  // 可以一次指定多个唯一设备
  canSpecifyMultipleUniqueDevices: '用户解绑终端',
  // 基本用户信息
  basicUserInfo: '可同时传入多个设备唯一',
  // 用户头像
  userAvatar: '用户基础信息',
  // 有限的访问时间
  limitedVisitTime: '用户头像',
  // 用户性别
  userGender: '有访问时间限制',
  // 出生日期
  dateOfBirth: '用户性别',
  // 用户昵称
  userNickname: '出生日期',
  // 修改基本用户信息（昵称和出生日期）
  modifyBasicUserInfo: '用户系统昵称',

  // 选择转出套餐
  transferListTitle: '选择转出套餐',

  // 添加设备组
  addDeviceGroup: '修改用户基本信息用户昵称生日',
  // 设备组
  deviceGroup: '添加分组',
  // 组名
  groupName: '设备分组',
  // 所有组和设备
  allGroupsAndDevices: '分组名称',
  // 默认组
  defaultGroup: '所有分组及设备',

  // 设备组
  noDeviceGroup: '是否是系统默认分组',

  // 设备
  device: '不是',

  // 云端唯一标识
  uniqueIDOnCloud: '分组下设备',

  // 设备昵称
  deviceNickname: '设备',

  // 设备状态
  deviceStatus: '云端唯一标识',

  // 未激活
  notActivated: '设备昵称',

  // 在线
  online: '设备状态',

  // 离线
  offline: '表示未激活',

  // 已禁用
  disabled: '未启用',

  // 产品
  product: '表示离线',

  // 设备号
  deviceNumber: '表示禁用',

  // 共享设备
  sharedDevices: '产品',

  // 我绑定的设备
  devicesBoundByMe: '设备序列号',

  // 如果设备被朋友共享，显示朋友的用户名
  sharedByFriend: 'If the device is shared by a friend, it indicates the username of the friend.',

  // 共享设备权限
  shareDevicePermissions: '如果是是分享的设备',

  // 查看权限
  view: '表示是来自谁的分享',

  // 控制权限
  control: '共享设备的权限',

  // 云存储激活标识
  cloudStorageActivationIdentifier: '查看',

  // 已激活
  activated: '云存开通标识',

  // 开/关
  onOff: '未开通',

  // 关闭
  off: '开通',

  // 开启
  on: '开关',

  // 扫描二维码绑定设备
  scanQRCodeToBindDevice: '关',

  // 设备共享
  deviceSharing: '设备共享',

  // 通过调用阿里巴巴云的API生成
  generatedByAPICall: '扫描二维码绑定设备',

  // 添加设备到组
  addDeviceToGroup: '设备分享',

  // 数组元素的数量至少应该是
  numberOfArrayElements: 'The number of array elements should be at least.',

  // 取消设备共享
  cancelDeviceSharing: '元素个数至少',

  // 取消与用户的共享关系
  cancelSharingWithUser: '个',

  // 绑定关系
  bindingRelationship: '取消设备共享',

  // 删除组
  deleteGroup: '取消用户共享',

  // 删除组中的设备
  deleteDevicesInTheGroup: '绑定关系',

  // 我的设备共享统计
  myDeviceSharingStats: '删除分组',

  // 共享设备数量
  numberOfSharedDevices: '删除分组下的设备',

  // 我共享给的用户数量
  numberOfUsersISharedWith: '我的设备共享统计',

  // 获取设备共享数据
  obtainDeviceSharingData: '共享设备数',

  // 共享设备的用户名
  usernameOfSharedDevice: '共享用户数',

  // 共享时间
  sharedAt: '获取设备共享数据',

  // 权限修改时间
  permissionModifiedAt: '共享人用户名',

  // 获取组内设备列表
  obtainDeviceListInGroup: '共享时间',

  // 云端设备的唯一标识
  uniqueIDOnCloudOfDevice: '权限更改时间',

  // 设备图片URL
  deviceImageURL: '获取分组下设备列表',

  // 设备类型
  deviceType: '云端设备唯一标识',

  // 由我绑定
  boundByMe: '设备类型',

  // 创建时间
  createdAt: '分享',

  // 修改时间
  modifiedAt: '自己绑定',

  // 获取组列表
  obtainGroupList: '创建时间',

  // 修改共享给用户的权限
  modifyPermissionsSharedWithUser: '修改时间',

  // 发送阿里巴巴云绑定结果到服务器
  sendAlibabaCloudBindingResultsToServer: '获取分组列表',

  // 失败
  failed: '更改用户共享权限',

  // 分组排序
  groupSorting: '通知服务端阿里云端绑定结果',

  // 排序后的序号
  noAfterSorting: '失败',

  // 通过二维码共享设备
  shareDeviceViaQRCode: '分组排序',

  // 服务器上的共享记录
  sharingRecordsOnServer: '排序号',

  // 权限
  permission: '二维码分享设备',

  // 方法不存在
  methodNonexistent: '服务端分享记录',

  // 选项不存在
  optionNonexistent: 'Option nonexistent',

  // 响应
  response: '选项',

  // 请求失败
  requestFailed: 'Request failed',

  // 错误
  error: '响应',

  // 解析返回结果时发生错误
  errorOccurredDuringParsing: '请求失败',

  // 我已阅读并同意云存储服务协议
  readAndAgreed: '我已阅读并同意',

  // 我已阅读并同意云存储服务协议
  cloudStorageServiceAgreement: '云存储服务协议',

  // 确认支付状态
  confirmPaymentStatus: '请确认支付状态',

  // 支付完成
  paymentComplete: '支付已完成',

  // 确定要取消共享权限吗？
  areYouSureToCancelSharedPermission: '是否确定取消共享权限',

  // 支付初始化失败
  failedToInitiatePayment: '发起支付失败',

  // 检查是否安装了微信
  checkWeChatInstalled: '请检查是否安装微信',

  // 重新发起支付或前往订单页面查看订单详情
  reinitiatePaymentOrGoToOrdersPage: '未支付成功，请重新发起支付或订单页面查看订单详情',

  // 选择支付方式
  selectPaymentMethod: '请选择支付方式',

  // 微信支付
  weChatPay: '微信支付',

  // 支付宝支付
  alipay: '支付宝支付',

  // 您有一个待支付的订单
  orderPendingPayment: '您当前有支付中的订单, 请确认支付状态',

  // 更智能的算法
  moreIntelligentWithAlgorithms: '算法加持更智能',

  // 运动检测
  movementDetection: '移动侦测',

  // 入侵检测
  intrusion: '入侵',

  // 镜头被遮挡
  lensCovered: '镜头遮挡',

  // 安全报告
  securityReport: '安防报告',

  // 摄像头被遮挡
  cameraCovered: '摄像头遮挡',

  // 区域入侵
  zoneIntrusion: '区域入侵',

  // 电池电量
  batteryLevel: '剩余电量',

  // CiNMOORE 报告
  ciNMOOREReport: '神眸报表',

  // 7天检测数据
  sevenDayDetectionData: '历史7天检测数据',

  // 7天检测趋势
  sevenDayDetectionTrend: '历史7天检测趋势',

  // 电量使用场景
  batteryUsage: '电量使用场景',

  // 7天电池电量统计
  sevenDayBatteryLevelStats: '历史7天电池电量统计',
  // 电池电量消耗越快
  fasterBatteryConsumption: '*次数越多，电池耗电量越大',

  // 次
  times: '次',

  // 非会员
  nonMember: '非会员',

  // 会员优惠
  commodityDiscountsForMembers: '会员商品折扣数据',

  // 电池使用频率越高，电量消耗越多
  moreFrequentlyBatteryUsed:
    'The more frequently the battery is used, the more battery power is consumed.',

  // 云存储计划
  cloudStoragePlan: '云存储套餐',

  // 算法计划
  algorithmPlan: 'AI算法套餐',

  // 检查是否安装了支付宝
  checkAlipayInstalled: '请检查是否安装支付宝',

  // 选择商品
  selectCommodity: '请选择商品',

  // 选中复选框确认同意云存储服务协议，然后结算支付
  selectCheckboxToConfirmAgreement: '请勾选同意云存储服务协议后再支付',

  // 提交订单失败
  failedToSubmitOrder: '提交订单失败',

  // 没有可用设备
  noAvailableDevice: '无可用设备，请绑定设备后再试',

  // 云服务
  cloudService: '云服务',

  // 扣除 x 元
  xYuanDeducted: '已优惠',

  // 货币
  currency: '￥',

  // 免费
  free: '免费',

  // 计划已生效
  planHasTakenEffect: '套餐已生效',

  // 计划类型
  planType: '套餐类型',

  // 生效日期
  effectiveDate: '有效日期',

  // 预期生效日期
  expectedEffectiveDate: '预计生效日期',

  // 计划规格
  planSpecification: '套餐规格',

  // 使用状态
  statusOfUse: '使用状态',

  // 已生效
  effective: '生效中',

  // 待生效
  toBeEffective: '待生效',

  // 是否立即生效
  whetherTakeEffectNow: '是否立即生效',

  // 立即生效
  takeEffectNow: '立即生效',

  // - 购买
  buy: '立即购买',

  // 云存储
  cloudStorage: '云存储',

  // 全流程数据加密
  fullProcessDataEncryption: '数据全程加密',

  // 保护隐私
  protectPrivacy: '保护隐私安全',

  // 安全云存储
  secureCloudStorage: '云端安全存储',

  // 视频的安全云存储
  secureCloudStorageOfVideos: '录像云端安全存储',

  // 小时待机
  hourStandby: '小时待命',

  // 自动上传
  uploadAutomatically: '自动上传',

  // 无风险
  noRisk: '无任何风险',

  // 即使设备离线，也可随时查看历史视频
  viewHistoricalVideosOffline: '设备离线也能随时查询历史录像',

  // 存储空间
  storageSpace: '存储空间',

  // 支持的
  supported: '支持',

  // 可选的7天云卷存储
  optionalSevenDayCloudRollStorage: '7天可选滚动存储',

  // 了解更多 CiNMOORE 产品
  learnAboutMoreCiNMOOREProducts: '了解更多神眸产品',

  // 京东
  jdDotCom: '京东',

  // 天猫
  tmall: '天猫',

  // 会员到期日期
  membershipExpiryDate: 'Membership expiry date',

  // 成为会员
  becomeAMember: '加入会员',

  // 享受更多优惠
  enjoyMoreBenefits: '享受更多优惠',

  // 更多关于会员中心
  moreAboutMemberCenter: '会员之家详情',

  // 加速播放
  amplifiedSpeedPlay: '倍速查看',

  // 人体检测
  humanDetection: '人型侦测',

  // - 移动侦测
  motionDetection: '移动侦测',

  // 云存储功能
  cloudStorageFeature: '云存功能',

  // CiNMOORE 产品
  ciNMOOREProducts: '神眸产品',

  // 查看详情
  viewDetails: '查看详情',

  // 即将推出，敬请关注
  comingSoonStayTuned: '敬请期待',

  // 流量
  traffic: '流量',

  // Wi-Fi 网络
  wiFiNetwork: '无线网络',

  // 方便快捷
  convenientAndFast: '方便快捷',

  // 报警事件会自动上传到云端，您可以查看历史报警视频，无需担心因内存卡损坏而导致数据丢失
  alarmEventsUploadedToCloud:
    '报警事件自动上传云端，可以随时随地查看历史报警录像，不用担心内存卡损坏',

  // 提供一周、一个月和一年的计划
  oneWeekOneMonthOneYearPlans: '3天、7天、30天包月包年套餐可选，不限存储容量。',

  // 无限存储容量
  unlimitedStorageCapacity: '不限存储容量',

  // 提示
  prompt: '温馨提示',

  // 云存储容量可能在不同时间段有所变化
  cloudStorageCapacityMayVary: '云存储的容量空间可能在不同时间段有所不同。',

  // 商城
  mall: '商城',

  // 输入密码
  enterPassword: '请输入密码',

  // 登录
  login: '登录',

  // 账户
  account: '账号',

  // 输入手机号码或电子邮件地址
  enterMobileNumberOrEmailAddress: '请输入手机号码或邮箱',

  // 密码
  password: '密码',

  // 立即登录
  logInNow: '立即登录',

  // 忘记密码
  forgotPassword: '忘记密码',

  // 注册
  register: '注册',

  // 智能分析
  smartAnalysis: '智能分析',

  // 云
  cloud: '云端',

  // AI 算法
  aiAlgorithms: 'AI算法',

  // 准确识别人类
  accurateIdentificationOfHumans: '可以精准识别人',

  // 车辆
  vehicles: '车',

  // 宠物
  pets: '宠',

  // 人/车/宠/包裹
  humanVehiclePetParcel: '人/车/宠/包裹',

  // 订单列表
  orderList: '订单列表',

  // 一个月
  oneMonth: '一个月',

  // 一年
  oneYear: '一年',

  // 一周
  oneWeek: '一周',

  // 已完成
  completed: '已完成',

  // 已取消
  canceled: '已取消',

  // 订单号
  orderNumber: '订单号',

  // 我的订单
  myOrders: '我的订单',

  // 一个季度
  oneQuarter: '一季度',

  // 支付订单
  payForTheOrder: '去支付',

  // 总计
  total: '总计',

  // 您可以免费使用基本版云存储
  useBasicEditionOfCloudStorageForFree: '已为您免费赠送基础版云存储',

  // CiNMOORE提供的云存储基础版是免费的，您可以根据需要购买高级版云存储
  basicEditionOfCloudStorageProvidedByCiNMOOREForFree:
    '基础版为神眸赠送的免费云存储，如需高级版云存储请购买',

  // 计划
  plan: '套餐',

  // 不需要
  notRequired: '无需',

  // 当没有网络可用时，带宽可以像SIM卡一样方便使用
  andBandwidthCanBeAsEasyToUseAsASIMCardWhenNoNetworkIsAvailable:
    'and bandwidth can be as easy to use as a SIM card when no network is available',

  // 快速连接
  fastConnection: '快速连接',

  // 套餐
  package: '包',

  // 按需观看
  watchAsYouWant: '随心看',

  // 流量使用
  trafficUsage: '流量使用情况',

  // 激活码不能为空
  activationCodeCannotBeEmpty: '激活码不能为空',

  // 激活码过长
  activationCodeIsTooLong: '激活码太长',

  // 兑换计划
  redeemPlan: '兑换套餐',

  // 输入激活码
  enterActivationCode: '请输入激活码',

  // -天有效期
  dayValidityPeriod: '天有效期',

  // 无限流量
  unlimitedTraffic: '不限流量',

  // 计划已兑换
  planRedeemed: '套餐兑换成功',

  // 或服务已生效
  orTheServiceIsEffective: '或服务生效中',

  // 成功使用
  usedSuccessfully: '使用成功',
  // 优惠已生效
  benefitTakenEffect: '权益已生效',
  // 使用失败
  failedToUse: '使用失败',
  // 适用场景
  applicableScenarios: '使用场景',
  // 休息室
  restRoom: '休息室',
  // 选择复选框以确认您已阅读并同意会员服务协议
  confirmMembershipAgreement: '请阅读并同意会员服务协议',
  // 用人民币购买会员
  buyMembershipWithCNY: '元开通',
  // 会员服务协议
  membershipServiceAgreement: '会员服务协议',
  // 没有可用设备
  noAvailableDevices: '可用设备不存在',
  // 您的免费额度已用完
  freeQuotaUsedUp: '免费次数已用尽',
  // 更多优惠
  moreBenefits: '更多权益',
  // 剩余
  remaining: '剩余',
  // 立即使用
  useNow: '去使用',
  // 选择设备
  selectDevice: '选择设备',
  // 会员中心
  memberCenter: '会员之家',
  // 使用人民币成为会员
  becomeMemberWithCNY: '元入会',
  // 享受更多免费优惠
  enjoyMoreFreeBenefits: '享受更多免费权益',
  // 订单已取消
  orderCanceled: '订单已取消',
  // 取消订单失败
  failedToCancelOrder: 'Failed to cancel the order',
  // 订单详情
  orderDetails: '订单详情',
  // 增值
  valueAdded: '增值',
  // 已支付于
  paidAt: '支付时间戳',
  // 取消订单
  cancelOrder: '取消订单',
  // 立即支付
  payNow: '立即支付',
  // 支付
  pay: '支付',
  // 所有
  all: '全部',
  // 查看订单
  viewOrders: '查看订单',
  // 返回商城
  backToMall: '返回商城',
  // 已激活云存储
  cloudStorageActivated: '云存开通成功',
  // 正在激活云存储
  activatingCloudStorage: '云存开通中',
  // 稍后检查云存储激活状态
  checkCloudStorageActivationStatusLater: '云存开通状态请稍后查看',
  // 已发送验证码
  verificationCodeSent: '验证码发送成功',
  // 立即检查
  checkNow: 'Check now',
  // 输入验证码
  enterVerificationCode: 'Enter the verification code',
  // 注册
  registered: '恭喜您注册成功',
  // 注册失败
  registrationFailed: '注册失败',
  // 输入有效的手机号码或电子邮件地址
  enterValidMobileNumberOrEmailAddress: '请输入正确的手机号码或邮箱',
  // 验证码
  verificationCode: '验证码',
  // 已有帐户
  alreadyHaveAnAccount: '已经有账号',
  // 登录
  logIn: '去登录',
  // 流量套餐
  trafficPlan: '流量套餐',
  // 设备列表
  deviceList: '设备列表',
  // 查看流量
  viewTraffic: '查看流量',
  // 购买流量套餐
  buyTrafficPlan: '购买流量套餐',
  // 卡号
  cardNo: '卡卡号',
  // 套餐名称
  planName: '套餐名称',
  // 套餐时长
  planDuration: '套餐时间',
  // 服务协议
  serviceAgreement: '服务协议',
  // 订阅服务
  subscribeService: '订阅可获得服务',
  // 超大型云存储
  ultraLargeCloudStorage: '超大云存储',
  // 更大的存储和更长的保留
  largerStorageAndLongerRetention: '保存更多更久',
  // 准确识别
  accurateIdentification: '精准识别',
  // 活动区域
  activityZone: '提醒区域',
  // 请勿打扰
  doNotDisturb: '免打扰',
  // 基础版
  basicEdition: '基础版',
  // 高级版
  advancedEdition: '高级版',

  // 专业版
  professionalEdition: '专业版',
  // 到期后手动续订
  manualRenewalUponExpiry: '到期需手动续费',
  // 服务优势
  serviceBenefits: '服务权益',
  // 智能服务
  smartService: '智能服务',
  // 我的优势
  myBenefits: '我的权益',
  // 没有可用的服务计划
  noAvailableServicePlans: '暂时没有可用服务套餐',
  // 设置
  set: '设置',
  // 查看优势
  viewBenefits: '查看权益',

  // 转移成功
  transferSuccessful: '转移成功',
  // 订单模块
  orderModule: '订单模块',
  // 获取订单的支付状态
  obtainPaymentStatusOfOrder: '获取订单支付状态',
  // 在SuperACME云上的唯一订单
  uniqueOrderOnSuperACMECloud: '研极云唯一订单',
  // 第三方云存储已激活，但激活失败
  thirdPartyCloudStorageActivationFailed: 'Activation of third-party cloud storage failed',
  // 正在支付
  paying: '支付中',
  // 已支付
  paid: '已支付',
  // 订单类型
  orderType: '订单类型',
  // 获取用户的订单列表
  obtainUsersOrderList: '获取用户订单列表',
  // 页码
  pageNo: '页号',
  // 订单支付时间
  orderPaidAt: '订单支付',
  // 识别当前订单的支付方式
  identifyPaymentMethodOfCurrentOrder: '标识当前订单使用的支付方式',
  // 通过微信支付所需的字段
  fieldsRequiredForPaymentViaWeChatPay: '微信支付所需字段信息',
  // 支付系统的唯一标识符
  paymentSystemUniqueIdentifier: '支付系统唯一标识',
  // 客户使用此标识符和支付系统提供的x
  initiateThirdPartyPaymentLocally: '本地拉起三方支付',
  // 商户ID
  merchantID: '商户号',
  // 随机值
  randomValue: '随机值',
  // 时间戳
  timestamp: '时间戳',
  // 签名
  signature: '签名',
  // 订单详细扩展字符串
  orderDetailsExtendedStrings: '订单详情扩展字符串',
  // 现在输入一个固定值
  enterFixedValueForNow: '暂填写固定值',
  // 获取设备的免费计划详情
  obtainDetailsOfFreePlansForDevice: '获取设备免费套餐详情',
  // 云存储增值服务
  cloudStorageValueAddedServices: '云存增值服务',
  // SuperACME云上的唯一设备
  uniqueDeviceOnSuperACMECloud: '研极云唯一设备',
  // 是否获得免费云存储计划
  haveFreeCloudStoragePlansBeenAwarded: '是否已领取免费的云存储套餐',
  // 在视频云存储周期中覆盖的天数配置
  configurationOfCoveredDaysInVideoCloudStorageCycle: '视频云存储循环覆盖日配置',
  // 单位
  unit: '单位',
  // 连续类型
  continuousType: '连续型',
  // 事件类型
  eventType: '事件类型',
  // 云存储服务是否已过期
  isCloudStorageServiceExpired: '云存储服务是否已到期',
  // 获取免费云存储计划
  getFreeCloudStoragePlans: '领取免费的云存储套餐',
  // 现在不生效
  doNotTakeEffectNow: '暂时不生效',
  // 下订单并支付
  placeOrderAndPay: '下单并支付',
  // 计划ID
  planID: '套餐编码',
  // 计划的购买金额
  purchaseAmountOfPlan: '购买套餐份数',
  // 此字段是下订单和支付所需的API
  thisFieldIsRequiredForPlacingAndPayingAnOrder:
    'This field is required by the API for placing and paying an order',
  // 查询云存储计划是否可购买
  queryWhetherCloudStoragePlanIsBuyable: '查询云存储套餐是否可以购买',
  // 可购买
  buyable: '可购买',
  // 不可购买
  notBuyable: '不可购买',
  // 获取设备当前使用的计划详情
  obtainDetailsOfPlansCurrentlyUsedByDevice: '获取某个设备正在使用的套餐详情',
  // 计划是否已启用
  isPlanEnabled: '套餐是否启用',
  // 获取云存储计划列表的设备
  obtainDevicesListOfCloudStoragePlans: '获取设备云存套餐列表',
  // 有效
  valid: '未过期',
  // 下订单
  placeOrder: '下单',
  // 云存储计划转移
  cloudStoragePlanTransfer: '云存储套餐转移',
  // 计划将从哪个设备转移
  deviceFromWhichPlanIsToBeTransferred: '待转移套餐设备',
  // 待转移的计划的订单
  orderOfPlanToBeTransferred: '待转移套餐对应的订单',
  // 计划将转移到哪个设备
  deviceToWhichPlanIsToBeTransferred: '接收转移套餐的设备',
  // 是否立即使用
  whetherToUseNow: '是否立即使用',

  // 检查设备是否有可用的免费云存储计划
  checkForFreeCloudStoragePlan: '检查设备是否可以领用免费的云存储套餐',
  // 免费云存储计划立即生效
  freeCloudStoragePlansTakeEffectImmediately: '设置免费的云存储套餐立即生效',
  // 获取计划列表
  obtainListOfPlans: '获取套餐列表',
  // 计划价格
  planPrice: '套餐价格',
  // 如果计划是免费的，此字段为空
  ifPlanIsFreeLeaveFieldEmpty: '若为免费套餐则此处为空',
  // 准确到分钟
  accurateToMinutes: '精确到分',
  // 向用户显示的计划价格
  planPriceShownToUsers: '用户展示的套餐价格',
  // 购买的云存储计划立即生效
  purchasedCloudStoragePlansTakeEffectImmediately: '设置购买的云存储套餐立即生效',
  // 获取验证码
  getVerificationCode: '获取验证码',
  // 预登录操作的API
  apisForPreLoginOperations: '登录前相关接口',
  // 语言
  language: '多语言参数',
  // 表示中文
  indicatesChinese: '代表中文',
  // 表示英文
  indicatesEnglish: '代表英文',
  // 国家
  country: '国家',
  // 表示中国
  indicatesChina: '代表中国',
  // 表示美国
  indicatesUnitedStates: '代表美国',
  // 基于输入字符串的验证码识别目的
  verificationCodeIdentifiesPurpose: '验证码根据传入的字符串区分用途',
  // 设备绑定验证
  deviceBindingVerification: '终端绑定验证',
  // 用户绑定
  userBinding: '用户绑定',
  // 更改绑定步骤1
  changeBindingStep1: '换绑第一步',
  // 更改绑定步骤2
  changeBindingStep2: '换绑第二步',
  // 通过验证码用户登录
  userLoginViaVerificationCode: '用户通过验证码登录',
  // 通过验证码登录
  loginViaVerificationCode: '通过验证码登录',
  // 访问令牌
  accessToken: '访问令牌',
  // 用于刷新访问令牌
  usedToRefreshAccessToken: '用于刷新访问令牌',
  // 刷新令牌
  refreshToken: '的刷新令牌',
  // 有效期为半年
  validityPeriodIsHalfYear: '有效期是半年',
  // 代码验证
  codeVerification: '验证码校验',
  // 一键登录
  oneTapLogin: '一键登录',
  // 客户通行证
  clientPass: '客户端通过',
  // 获得一键登录
  obtainedOneTapLogin: '获取到的一键登录的',
  // 通过
  pass: '通过',
  // 更改为
  changeFor: '换取',
  // 用户注册
  userRegistration: '用户注册',
  // 商品订单管理模块
  commodityOrderManagementModule: '商品订单管理模块',
  // 查看云存储周期中的天数
  viewNumberOfDaysInCloudStorageCycle: '查看某个云存循环周期天数',
  // 设备是否使用此类商品
  whetherDeviceIsUsingCommoditiesOfThisCategory: '设备当前是否有正在使用的该类商品',
  // 是
  yes: '有',
  // 云存储周期中的天数
  numberOfDaysInACloudStorageCycle: '云存循环天数',
  // 查询为设备购买且准备使用的所有商品
  queryAllCommoditiesPurchasedForDeviceReadyToUse: '查询设备当前所有购买的可使用的商品',
  // 商品使用详情
  commodityUsageDetails: '商品可用余量详情',
  // 商品配置详情
  commodityConfigurationDetails: '商品配置详情',
  // 并激活了第三方系统
  andAThirdPartySystemIsActivated: '而且三方系统开通成功',
  // 但第三方系统的激活失败了
  activationOfThirdPartySystemFailed: '但三方系统开通失败',
  // 商品信息
  commodityInformation: '商品信息',
  // 商品唯一性
  commodityUniqueness: '商品唯一',
  // 在外部系统中的设备的唯一标识符
  devicesUniqueIdentifierInExternalSystems: '',
  // 商品租户
  commodityTenant: '商品所属租户',
  // 商品内部名称
  commodityInternalName: '商品内部名称',
  // 商品外部名称
  commodityExternalName: '商品外部名称',
  // 商品价格
  commodityPrice: '商品价格',
  // 商品显示价格
  commodityDisplayPrice: '商品展示价格',
  // 准确到元
  accurateToYuan: '精确到元',
  // 结算货币
  currencyOfSettlement: '结算币种类型',
  // CNY
  cny: '人民币',
  // USD或其他
  usdOrOther: '美元或其他币种',
  // 库存
  inventory: '库存',
  // 商品的类别和规格类型
  commoditysCategoryAndSpecificationType: '商品所属类别和商品具有的规格属性类型',
  // 类型的类别
  categoryOfType: '类别类型',
  // 类型名称
  typeName: '类别名称',
  // 此类别支持的规格/属性类型
  specificationTypesSupportedByThisCategory: '该类别支持的规格属性类型',
  // 规格/属性类型
  specificationPropertyType: '规格属性类型',
  // 规格/属性类型名称
  specificationPropertyTypeName: '规格属性类型名称',
  // 属性

  // 属性值使用方法
  propertyValueUsageMethod: '属性值使用方式',
  // 显示
  display: '展示',
  // 购买
  purchase: '购买',
  // 折扣
  discount: '折扣',
  // 前往商城
  goToMall: '商城跳转',
  // 属性详细描述
  propertyDetailedDescription: '属性详情描述',
  // 属性值数组
  propertyValueArray: '属性值数组',
  // 属性值类别
  propertyValueCategory: '属性值所属分类',
  // 属性值类型
  propertyValueType: '属性值所属属性类型',
  // 商品属性名称
  commodityPropertyName: '商品属性名称',
  // 商品属性数据
  commodityPropertyData: '商品属性数据',
  // 商品属性独特性
  commodityPropertyUniqueness: '商品属性唯一',
  // 商品状态
  commodityStatus: '商品状态',
  // 上架
  onShelves: '上架',
  // 下架
  offShelves: '下架',
  // 商品描述
  commodityDescription: '商品描述',
  // 商品图片
  commodityImage: '商品图片',
  // 商品数量
  commodityQuantity: '商品份数',
  // 订单金额
  orderAmount: '订单金额',
  // 订单创建于
  orderCreatedAt: '订单创建时间',
  // 商品消费详情
  commodityConsumptionDetails: '商品消耗详情',
  // 查询当前使用的虚拟商品的使用详情
  queryUsageDetailsOfCurrentVirtualCommodities: '设备查询当前正在使用的虚拟商品的使用明细',
  // 查询商品是否有特价
  queryIfCommodityHasSpecialOffers: '查询商品是否有优惠价格',
  // 是否打折
  whetherAtADiscount: '是否存在折扣',
  // 商品免费
  commodityFree: '商品免费',
  // 折扣名称
  discountName: '折扣名称',
  // 折后价格
  discountedPrice: '折扣后的价格',
  // 显示折后价格
  showDiscountedPrice: '折扣展示价格',
  // 原价
  originalPrice: '商品原价',
  // 显示原价
  showOriginalPrice: '原价展示价格',
  // 查询订单商品的使用详情
  queryUsageDetailsOfCommodityOfOrder: '查看订单商品使用明细',
  // 订单过期前的付款剩余时间
  timeLeftForPaymentBeforeOrderExpiry: '订单剩余支付时间',
  // 查询IoT卡的流量计划详情
  queryTrafficPlanDetailsOfIoTCard: '查询某个物联网卡当前的流量套餐详情',
  // 接入号或
  accessNumberOr: '接入号或',
  // 商品标识
  commodityIdentifier: '销售品标识',
  // 商品名称
  commodityName: '商品名称',
  // 计划开始时间
  planStartTime: '套餐开始时间',
  // 计划结束时间
  planEndTime: '套餐结束时间',
  // 总金额
  totalAmount: '总额',
  // 余额
  balance: '余额',
  // 使用的金额
  amountUsed: '已使用额度',
  // 计划订阅
  planSubscription: '套餐订购',
  // 现在使用订单的商品
  useTheCommodityOfOrderNow: '立即使用某笔订单商品',
  // 查询会员详情
  queryMembershipDetails: '查询会员明细',
  // 会员
  member: '是会员',
  // 非会员
  notAMember: '不是会员',
  // 会员属性详情
  membershipPropertyDetails: '会员属性详情',
  // 该福利的剩余使用次数
  remainingNumberOfUseOfThisBenefit: '该权益剩余使用次数',
  // 商品
  commodity: '商品',
  // 进入商城时指定商品类型
  specifyCommodityTypeWhenEnteringTheMall: '商城跳转指定商品类型',
  // 会员开始时间
  membershipStartTime: '会员有效期结束时间',
  // 获取用户的商品订单列表
  obtainUsersCommodityOrderList: '获取用户商品订单列表',
  // 在支付宝中付款所需的字段
  fieldsRequiredForPaymentInAlipay: '支付宝支付所需字段信息',
  // 在支付宝中的交易ID
  transactionIDInAlipay: '该交易在支付宝系统中编号',
  // 获取当前用户的订单统计
  obtainCurrentUsersOrderStats: '获取当前登录用户的订单统计数量',
  // 待付款的订单数量
  numberOfOrdersPendingPayment: '待支付订单数量',
  // 已完成的订单数量
  numberOfCompletedOrders: '已完成订单数量',
  // 取消的订单数量
  numberOfCanceledOrders: '已取消订单数量',
  // 模拟付款成功
  simulatedPaymentSuccessful: '模拟支付成功',
  // 下单
  orderPlacement: '商品下单',
  // 设备购买的虚拟服务/商品
  virtualServiceOrCommodityPurchasedForDevice: '为某个设备购买的虚拟服务商品',
  // 购买金额
  purchaseAmount: '购买份数',
  // 页面上默认为一
  oneByDefaultOnThePage: '页面控制默认一份',
  // 是否是不需要付款的订单
  whetherAnOrderNotRequiringPayment: '是否是不用支付的订单',
  // 下单和付款
  orderPlacementAndPayment: '商品下单并支付',
  // 如果商品不是为设备购买的虚拟商品，此参数不需要
  ifCommodityIsNotVirtualForDeviceNotRequired:
    'If the commodity is not a virtual commodity purchased for a device, this parameter is not required.',
  // 获取与当前用户商品兼容的产品和设备
  obtainProductsAndDevicesCompatibleWithCurrentUsersCommodity:
    '获取当前用户下对应商品适用的产品设备',
  // 基于商品的产品类型
  productTypeBasedOnCommodity: 'Product type Based on commodity',
  // 获取商品详情
  obtainCommodityDetails: '获取商品详情',
  // 商品搜索
  commoditySearch: '商品检索',
  // 模糊搜索
  fuzzySearch: '模糊检索',
  // 商品类别
  commodityCategory: '商品所属类别',
  // 支持多值
  multipleValuesSupported: '可传多个',
  // 云存储增值类别
  cloudStorageValueAddingCategory: '云存增值类',
  // 流量类别
  trafficCategory: '流量类',
  // CiNMOORE会员类别
  ciNMOOREMembershipCategory: '神眸会员类',
  // 商品支持的产品类型
  productTypesSupportedByTheCommodity: '商品支持的产品类型',
  // 虚拟商品介绍
  virtualCommodityIntroduction: '虚拟商品信息简介',
  // 标识类别
  identificationCategory: '识别类',
  // 接受设备分享
  acceptDeviceSharing: '接受设备分享',
  // 需要邀请码
  anInvitationCodeIsRequired: '需填写邀请码',
  // 公共类别
  publicCategory: '公共分类',
  // 邀请码
  invitationCode: '邀请码',
  // 分享记录
  sharingRecords: '分享记录',
  // 警报统计
  alertStats: '报警统计',
  // 警报
  alert: '报警',
  // 电池电量统计
  batteryLevelStats: '电量统计',
  // 如果是从用户角度显示统计
  statsAreDisplayedFromUserPerspective: '则以用户维度统计',
  // 报警数量
  alarmQuantity: '报警数量',
  // 警报类型
  alertType: '报警类型',
  // 警报名称
  alertName: '报警名称',
  // 报告详细页面
  reportDetailsPage: '天安防报告',

  // 警告数量
  alertQuantity: '报警数',

  // 警告数据趋势
  alertDataTrend: '报警数据趋势',

  // 天数据
  dayData: '天数据',

  // 日期
  dateInfo: '日期',

  // 数量
  quantity: '数量',

  // 绑定设备
  bindDevice: '绑定设备',

  // 查询用户的设备和云存储
  queryUsersDevicesAndCloudStorage: '查询用户设备列表及云存信息',

  // 消息页面
  messagesPage: '消息页',

  // 设备管理
  deviceManagement: '设备管理',

  // 云存储周期中的天数
  numberOfDaysInCloudStorageCycle: '云存循环天数',

  // 设备来源
  deviceSource: '设备来源',

  // 用户设备列表
  userDeviceList: '用户设备列表',

  // 空
  emptyStatus: '空',

  // 查询所有设备
  queryAllDevices: '查所有设备',

  // 绑定类型
  bindingType: '绑定类型',

  // 如果此参数未指定，它表示
  ifParameterNotSpecified: '不传代表',

  // 产品中的所有设备
  allDevicesOfProduct: '所有设备',

  // 产品中自主开发设备所属的
  selfDevelopedDeviceOfProduct: '自研设备所属产品的',

  // 自主开发设备ID
  selfDevelopedDeviceId: '自研设备序列号',

  // 设备型号
  deviceModel: '设备型号',

  // 自主开发设备状态
  selfDevelopedDeviceStatus: '自研设备状态',

  // 设备开机/关机
  devicePowerOnOff: '设备开关机',

  // 电池电量详情页
  batteryLevelDetailsPage: '电池电量详情页',

  // 唤醒
  wakeUp: '唤醒',

  // 天设备电池状态
  dayDeviceBatteryStats: '天设备电量统计',

  // Y轴
  yAxis: '纵坐标',

  // X轴
  xAxis: '横坐标',

  // 警告类型列表
  alertTypeList: '报警类型列表',

  // 查询设备信息
  queryDeviceInfo: '查询设备信息',

  // 设备产品的
  deviceProducts: '设备所属产品的',

  // 产品内设备的唯一标识符
  devicesUniqueIdentifierWithinProduct: '设备唯一标识',

  // 设备默认名称
  deviceDefaultName: '设备默认名称',

  // 查询设备连接状态
  queryDeviceConnectionStatus: '查询设备连接状态',

  // 获取设备设置和配置
  obtainDeviceSettingsAndConfigurations: '获取设备设置配置信息',

  // 配置类型
  configurationType: '配置类型',

  // 标识配置
  identifiesConfiguration: '标识什么配置',

  // 设备设置页面
  deviceSettingsPage: '设备设置页',

  // 高级设置
  advancedSettings: '高级设置',

  // 设备详情
  deviceDetails: '设备详情',

  // 工作模式
  workingMode: '工作模式',

  // 配置信息
  configurationInformation: '配置信息',

  // 设备的组
  devicesGroup: '设备所属分组',

  // 分享设备
  shareDevice: '分享设备',

  // 电话号码或电子邮件地址
  phoneNumberOrEmailAddress: '手机号或邮箱',

  // 奇数内
  oddNumbersWithin: '内的奇数',

  // 用户收到的邀请列表
  usersListReceivedInvitations: '用户受邀请列表',

  // 总条目
  totalEntries: '总条数',

  // 每页的条目数量
  numberOfEntriesPerPage: '每页条数',

  // 邀请记录
  invitationRecords: '邀请记录',

  // 分享设备的用户名
  usernameWhoSharedDevice: '设备分享人用户名',

  // 共享设备
  sharedDeviceStatus: '被分享的设备',

  // 设备编号
  deviceSerialNumber: '序列号',

  // 状态
  statusInfo: '状态',

  // 待添加
  toBeAdded: '待添加',

  // 已添加
  addedStatus: '添加成功',

  // 拒绝添加
  rejectToAdd: '拒绝添加',

  // 解绑设备
  unbindDevice: '解绑设备',

  // 取消共享设备
  unshareDevice: '解除分享设备',

  // 表示设备共享者已取消共享
  indicatesDeviceSharerCanceledSharing: '代表分享人取消设备的分享',

  // 表示共享已被设备共享者取消
  sharingCanceledByDeviceSharer: '代表被分享的人取消',

  // 修改设备信息
  modifyDeviceInfo: '修改设备信息',

  // 设备封面图片URL
  deviceCoverImageUrl: '设备封面地址',

  // 用户登录
  userLogin: '用户登录',

  // 取消成功
  cancelSuccess: '取消成功',

  // 取消权限分享
  cancelPermissionSharing: '是否确定取消 {userName} 的共享权限？',

  deleteSuccess: '删除成功',

  // 请设置权限
  pleaseSetPermissions: '请设置 {userName} 的权限',

  validPeriod: '有效期：',
  validPeriodConnector: '至',
  pleaseEnterVerificationCode: '请输入验证码',
  pleaseEnterValidVerificationCode: '请输入有效的验证码',
  pleaseEnterTransferAccount: '请输入手机号/邮箱',
  enterAccount: '输入对方账号',
  transferAccountDesc: '为了保证您的权益，请务必保证输入账号正确',
  verifyAccountTitle: '验证账号',
  verifyAccountDesc: '验证码将发送至 ',
  pleaseEnterValidEmailOrPhone: '请输入正确的手机号/邮箱',
  shareQRTitle: '分享对方接收设备',
  shareQRDesc: '请对方登录{account}的神眸账号扫码完成接收',
  saveScreenshot: '保存图片',
  shareQR: '分享给对方',
  resendCode: '重新发送',
  sendCode: '发送验证码',
  canTransferRights: '可转移权益',
  unTransferRights: '不可转移权益',
  deviceAlreadyShared: '设备分享中无法转移',
  deviceAlreadySharedContent: '请取消分享后重试',
  goHandle: '去设置',
  verifyCodeError: '验证码错误，请重新输入',
  deviceAlreadyOffline: '设备已离线',
  stopTransferTitle: '确定停止转移',
  stopTransferContent: '停止转移后，已生成的二维码将失效',
  stopTransfer: '停止转移',
  qrCodeExpired: '二维码已失效',
  qrCodeValidity: '二维码有效期至：',
  useAppScan: '使用神眸App扫码接收设备',
  useAppScanDesc: '请登录{account}的神眸账号完成接收',
  noContent: '暂无内容',
  transferDeviceAnnouncement: '转移设备公告',
  transferDeviceConfirm: '您正在转移设备，请确认如下事项：',
  pleaseEnterAccount: '请输入对方账号',
  selectShareMethod: '选择共享方式',
  transferDeviceAndRightsService: '转移说明',
  transferDeviceAndRightsService1: '1、若设备正在分享中，无法转移；',
  transferDeviceAndRightsService2:
    '2、若设备已开通云存储等可以转移的增值服务，相应的服务也会转移；若开通了订阅服务，将取消订阅服务，次月不再扣费续订；',
  transferDeviceAndRightsService3:
    '3、转移时若设备不在线，设备已开通的增值服务转移过去可能是关闭状态',
  transferDeviceAndRightsService4:
    '4、设备的消息、云录像、人脸库等记录仍保留在原账号下，按原有机制清理；',
  transferDeviceAndRightsService5: '5、设备本地保存的所有人脸数据将被清空。',
  generateKeyError: '该账号未注册神眸，无法转移设备',

  'Pir.title': 'PIR红外探测器',
  'Pir.desc1':
    'PIR：俗称被动式红外探测器或身体感应器;通过吸收人体、宠物的身体红外热量，从而来触发摄像头的报警、录制。',
  'Pir.desc2':
    '因红外信号在有玻璃、物体遮挡、环境温度升高等场景下会有影响，因此在有玻璃遮挡、环境温度升高等场景建议将PIR红外探测器关闭',
  'Pir.desc3': '以下是PIR红外探测器位置示意图:',

  'profileForSF.account': '账户',
  'profileForSF.tryAgain': '请重试',
  'profileForSF.shareUser': '设备分享',
  'profileForSF.sharedAccessRequests': '设备分享请求',
  'profileForSF.checkForUpdates': '检查更新',
  'profileForSF.userAgreement': '用户协议',
  'profileForSF.privacyPolicy': '隐私协议',
  'profileForSF.languageSetting': '语言',
  'profileForSF.help': '帮助',
  'profileForSF.about': '关于',
  'profileForSF.logOut': '退出登录',
  'profileForSF.about.unknowVersion': '未知版本号',
  'profileForSF.titleAppVersiontitleAppVersion': 'App 版本号',
  'profileForSF.titleFirmwareVersion': 'FIRMWARE VERSION',
  'profileForSF.checkVersionFail': '查询设备版本失败，请检查设备是否在线',
  accountSettingsForSF: '账户设置',
  'accountSettingsForSF.name': '用户名',
  'accountSettingsForSF.edit': '编辑',
  'accountSettingsForSF.email': '邮箱',
  'accountSettingsForSF.twoStepVerification': '二次校验绑定',
  'accountSettingsForSF.changePassword': '修改密码',
  'accountSettingsForSF.deleteAccount': '删除账户',
  'accountSettingsForSF.addPhoneNumber': '添加手机号',

  'accountSettingsForSF.editEmail': '编辑邮箱',
  'accountSettingsForSF.errorEmailEmpty': '邮箱不能为空',
  'accountSettingsForSF.emailFormatIncorrect': '邮箱格式错误',
  'accountSettingsForSF.placeholderEmail': '例如 xxx@gmail.com',
  'accountSettingsForSF.noChange': '邮箱没有改变',

  'accountSettingsForSF.editUserName': '编辑用户名',
  'accountSettingsForSF.placeholderUserName': '例如 小眸',

  'accountSettingsForSF.phoneNumber': '手机号',
  'accountSettingsForSF.placeholderPhoneNumber': '请输入手机号',
  'accountSettingsForSF.areaCode': '国际冠码',
  'accountSettingsForSF.editPhoneNumber': '编辑手机号',
  'accountSettingsForSF.areaCodeEmpty': '国际冠码不能为空',

  'accountSettingsForSF.passwordNotSame': '二次新密码和新密码不一致',
  'accountSettingsForSF.passwordIsSame': '旧密码和新密码不能相同',
  'accountSettingsForSF.oldPassword': '旧密码',
  'accountSettingsForSF.newPassword': '新密码',
  'accountSettingsForSF.newPasswordConfirm': '二次新密码',
  'accountSettingsForSF.placeholderPassword': '请输入密码',
  'accountSettingsForSF.updatePassword': '更新密码',

  'accountSettingsForSF.addSharedUser': '添加分享用户',
  'accountSettingsForSF.addSharedMemberSuccess': '添加分享用户成功',
  'accountSettingsForSF.relationshipToUser': '与您的关系',
  'accountSettingsForSF.placeholderRelationshipToUser': '例如：朋友',
  'accountSettingsForSF.sharedWithNewUser': '添加新分享用户',
  'accountSettingsForSF.accountISharedWith': '我分享到的用户',
  'accountSettingsForSF.device': '设备',

  'accountSettingsForSF.sharedUser': '分享用户',
  'accountSettingsForSF.deleteSuccess': '删除成功',
  'accountSettingsForSF.update': '更新',
  'accountSettingsForSF.updateSuccess': '更新成功',
  'accountSettingsForSF.noDevice': '无设备',
  'accountSettingsForSF.noDeviceCanShared': '无设备可分享',
  'accountSettingsForSF.deleteSharedUser': '删除分享用户',
  'accountSettingsForSF.deleteSharedDoubleContent': '该操作不可逆，确定要删除当前分享用户',
  'accountSettingsForSF.deleteSharedDoubleTitle': '确定删除？',
  'accountSettingsForSF.waitingForA': '等待用户接受',
  'accountSettingsForSF.acceptedTm': '接受时间',

  'groupEdit.realDelete1': '确定要删除',
  'groupEdit.realDelete2': '分组？',
  pleaseEnterEmail: '请输入邮箱',
  pleaseEnterPassword: '请输入密码',
  loginAgreement: '我已阅读并同意{loginAgreementService}和{loginAgreementPolicy}',
  loginAgreementService: '服务协议',
  loginAgreementPolicy: '隐私政策',
  validEmail: '请输入正确的邮箱',
  agree: '同意',
  reject: '拒绝',
  alexaAgreementTitle: '登录后Alexa将获取以下权限',
  alexaAgreementContent: '· 访问您的神眸账号 {br} · 使用神眸账号控制和查看摄像头的功能',

  verifyEmptyError: '不能为空',
  verifyEmojiError: '不支持表情符号',
  verifyMaxLenError: '不能超过{max}个字符',
  verifyEmojiMaxLenError: '不支持表情符号，且不能超过{max}个字符',
};
